import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { UButtonComponent } from '@local/ui-infra';
import { SortService } from 'src/app/bar/services/sort.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { getSortOptions } from '../../../results/utils/sorts.utils';
import { SearchParamsService } from 'src/app/bar/services/search-params.service';
import { Search } from '@local/client-contracts';

export interface SectionButtons {
  seeAll: boolean;
  sort: boolean;
  contextMenu: boolean;
}

@UntilDestroy()
@Component({
  selector: 'widget-title',
  templateUrl: './widget-title.component.html',
  styleUrls: ['./widget-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetTitleComponent {
  sortPopupActive: boolean = false;
  @Input() currentSort: Search.Sort;
  @Input() title: string;
  @Input() sectionButtons: SectionButtons;
  @Input() isSmallScreen: boolean;
  @Input() contextMenuOpened: boolean;
  @Input() view: string = 'default';
  @Input() movedWidget: boolean;
  @Input() allowWidgetHandler: boolean = true;

  @Output() openContextMenu: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  @Output() sortPopupOpened: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() searchSort: EventEmitter<Search.Sort> = new EventEmitter<Search.Sort>();
  @Output() navigate: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild('actions') actionElementRef: ElementRef;

  constructor(
    private cdr: ChangeDetectorRef,
    public sortService: SortService,
    public searchParamsService: SearchParamsService
  ) {}

  openSort(elm: UButtonComponent) {
    const popupRefSort = this.sortService.openSortPopup(elm.button, { sortOptions: getSortOptions(this.view) }, this.currentSort, false);
    this.updateSortPopup(true);

    popupRefSort.close$.pipe(untilDestroyed(this)).subscribe(() => {
      this.updateSortPopup(false);
    });
    popupRefSort.compInstance.onSortEvent.subscribe((searchSort: Search.Sort) => {
      this.updateSortPopup(false);
      this.searchSort.emit(searchSort);
    });
  }

  private updateSortPopup(mode: boolean): void {
    this.sortPopupActive = mode;
    this.sortPopupOpened.emit(mode);
    this.cdr.markForCheck();
  }

  getActionRefWidth(): number {
    return this.actionElementRef?.nativeElement?.offsetWidth || 0;
  }
}
